import { storageKey } from "../constants/persistStorage";

const STORAGE_TYPE = "localStorage";

export const setPersistData = (data: any) => {
  window[STORAGE_TYPE].setItem(storageKey, JSON.stringify(data));
};

export const getPersistData = () => {
  return JSON.parse(window[STORAGE_TYPE].getItem(storageKey));
};

export const removePersistData = () => {
  window[STORAGE_TYPE].removeItem(storageKey);
};
